class CursorZoom {

	constructor($el, $container) {

		this.$el = $el;
		this.$container = $container;

		//

		this.$inner = this.$el.find('.cursor-zoom--inner');
		this.$outer = this.$el.find('.cursor-zoom--outer');

		this._frameStep;
		this._shakeInterval;
		this._lastX;
		this._lastY;

		//

		$(() => {
			this._onDomReady();
		});
	}

	//

	_onDomReady(){
		this._addListeners();
	}

	//

	_addListeners(){

		this.$container.on('mouseenter', this._onPhotoOver.bind(this));
		this.$container.on('mouseleave', this._onPhotoOut.bind(this));
		this._tick(true); // start following mouse
	}

	//

	_onPhotoOver(){
		this.enable();
	}

	_onPhotoOut(){
		this.disable();
	}

	//

	enable(){

		if(!this._shakeInterval){
			this._shakeInterval = window.setInterval(() => {
				this._shake();
			}, window.SETTINGS.frameInterval);
		}

		// this._tick(true); // start loop
		this.$el.addClass('is-active');
	}

	disable(){

		if(this._shakeInterval){
			window.clearInterval(this._shakeInterval);
			this._shakeInterval = null;
		}

		// this._frameStep = false; // kill loop
		this.$el.removeClass('is-active');

		TweenMax.set([this.$outer, this.$inner], {clearProps:'x, y, rotation, scale, force3D'});
	}

	//

	_tick(frameStep){

		if(typeof(frameStep) === 'boolean'){ this._frameStep = frameStep; }

		if(this._frameStep){
			this._moveCursor();
			window.requestAnimationFrame(this._tick.bind(this, null));
		}
	}

	_moveCursor(){

		let pageX = window.SETTINGS.coords.pageX;
		let pageY = window.SETTINGS.coords.pageY;
		let bounds = window.utils.PositioningUtils.getExtendedOffset(this.$container);

		if(!isNaN(pageX) && !isNaN(pageY)){

			TweenMax.set(this.$el, {x:pageX - bounds.left, y:pageY - bounds.top});

			if(isNaN(this._lastX) || isNaN(this._lastY)){
				this._lastX = pageX;
				this._lastY = pageY;
			}
		}

		// if(!isNaN(this._lastX) && !isNaN(this._lastY)){

		// 	let delta = (pageX - this._lastX) * (pageY - this._lastY);
		// 	let multiplier = 0.5;

		// 	TweenMax.set(this.$inner, {rotation: delta * multiplier});

		// 	this._lastX = pageX;
		// 	this._lastY = pageY;
		// }
	}

	_shake(shakeIntensity){

		if(!shakeIntensity){ shakeIntensity = 1; }

		let rotationIntensity = shakeIntensity * 5;

		TweenMax.set(this.$outer, {
			x:shakeIntensity/2 - Math.random() * shakeIntensity,
			y:shakeIntensity/2 - Math.random() * shakeIntensity,
			rotation: rotationIntensity/2 - Math.random() * rotationIntensity
		});

		this._shakeIndex++;
	}

	//
}

module.exports = CursorZoom;
